import { useEffect, useRef } from "react";
import QRCode from "qrcode";

/**
 * Renders a QR code to a canvas. Dark brand ink (#1b1817) on white for a soft,
 * scannable look. Decorative for AT — the same URL is announced elsewhere.
 */
export function QrCode({ value, size = 80 }: { value: string; size?: number }) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    QRCode.toCanvas(canvas, value, {
      width: size,
      margin: 1,
      color: { dark: "#1b1817", light: "#ffffff" },
    }).catch(() => {});
  }, [value, size]);

  return (
    <canvas
      ref={ref}
      width={size}
      height={size}
      className="block"
      style={{ width: size, height: size }}
      aria-hidden
    />
  );
}
